import { gql } from 'apollo-boost';
export const SET_FOLDER_REFERENCE = gql`
    mutation setFolderReference($data: SetFolderReferenceInput!) { setFolderReference(data: $data) }
`;
export const JOIN_PUBLISHED_FOLDER = gql`
    mutation joinPublishedFolder($token: String!) { joinPublishedFolder(token: $token) }
`;
export const ADD_PUBLISHED_MESSAGE = gql`
    mutation addPublishedMessage($data: AddPublishedMessageInput!) {
        addPublishedMessage(data: $data) { id body title createdAt }
    }
`;

export const SET_FOLDER_REFERENCE_FAVORITE = gql`
    mutation setFolderReferenceFavorite($referenceId: ID!, $favorite: Boolean!) {
        setFolderReferenceFavorite(referenceId: $referenceId, favorite: $favorite)
    }
`;
